import axios from 'axios'
import { useEffect, useState } from 'react'

import { fetchLogEvent } from '../features/master/masterAPI'

export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export function getCookie(cname: string) {
    // if (isLocalhost) {
    //     return 'A'
    // }
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    if (cname === 'CoRoot') {
        return 'A'
    }
    return ''
}

export interface LogEventProps {
    eventName: string
    string2?: string
    string3?: string
    decimal1?: number
    decimal2?: number
    datetime1?: Date
    datetime2?: Date
    messageBody?: string
}

export const logEvent = async (props: LogEventProps) => {
    const { eventName, string2, string3, decimal1, decimal2, datetime1, datetime2, messageBody } =
        props
    const res: any = await axios.get('https://geolocation-db.com/json/')

    fetchLogEvent({
        EventName: eventName,
        String1: res.data.IPv4 || '',
        String2: string2,
        String3: string3,
        Decimal1: decimal1,
        Decimal2: decimal2,
        Datetime1: datetime1,
        Datetime2: datetime2,
        MessageBody: messageBody,
    })
}

export const getCompanyFromURL = () => {
    if (window.location.hostname.toUpperCase().includes('A3IM')) {
        return 'C'
    } else {
        return 'A' // Localhost, awc-inc
    }
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window
    return {
        width,
        height,
    }
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
}

// Add number of years to a date
export function addYears(date: Date, years: number) {
    date.setFullYear(date.getFullYear() + years)
    return date
}

export const createSyntheticEvent = <T extends Element, E extends Event>(
    event: E
): React.SyntheticEvent<T, E> => {
    let isDefaultPrevented = false
    let isPropagationStopped = false
    const preventDefault = () => {
        isDefaultPrevented = true
        event.preventDefault()
    }
    const stopPropagation = () => {
        isPropagationStopped = true
        event.stopPropagation()
    }
    return {
        nativeEvent: event,
        currentTarget: event.currentTarget as EventTarget & T,
        target: event.target as EventTarget & T,
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        defaultPrevented: event.defaultPrevented,
        eventPhase: event.eventPhase,
        isTrusted: event.isTrusted,
        preventDefault,
        isDefaultPrevented: () => isDefaultPrevented,
        stopPropagation,
        isPropagationStopped: () => isPropagationStopped,
        persist: () => {},
        timeStamp: event.timeStamp,
        type: event.type,
    }
}
